window.onscroll = getScrollPosition;

function getScrollPosition(){
    if (document.querySelector('.section.cytat') == null) return false

    var maxDistance = 300;
    var bounding = document.querySelector('.section.cytat').getBoundingClientRect();

    console.log(bounding.top + bounding.height / 2 - window.innerHeight / 2)

    var distanceFromTop = (bounding.top + bounding.height / 2 - window.innerHeight / 2)
    if(distanceFromTop > 0){
        var distanceFromTopPercent = distanceFromTop / window.innerHeight * 100

        if(distanceFromTopPercent > 100){
            distanceFromTopPercent = maxDistance
        }
    } else {
        distanceFromTopPercent = 0
    }

    document.querySelector('.cyt-top').style = 'transform: translate(' + distanceFromTopPercent + '%, 0)';
    document.querySelector('.cyt-bottom').style = 'transform: translate(-' + distanceFromTopPercent + '%, 0)';
}
